module.exports = clamp

function clamp(value, min, max) {
  return min < max
    ? (value < min ? min : value > max ? max : value)
    : (value < max ? max : value > min ? min : value)
}



/*****************
 ** WEBPACK FOOTER
 ** /Users/kylemathews/programs/typography.js/packages/typography-design-tools/~/clamp/index.js
 ** module id = 459
 ** module chunks = 0
 **/